module.exports = __webpack_public_path__ + "img/icon-success.0376c42b.png";